import { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { cn } from "@/shared/libs/utils";
import { Button } from "@/shared/components/ui/button";

interface DataTableColumnHeaderProps<TData, TValue>
  extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>;
  title: string;
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className)}>{title}</div>;
  }

  const sorted = column.getIsSorted();

  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <Button
        variant="ghost"
        size="sm"
        className="-ml-3 h-8 hover:bg-accent"
        onClick={() => {
          // 첫 클릭: 내림차순 (desc)
          // 두 번째 클릭: 오름차순 (asc)
          // 세 번째 클릭: 정렬 해제
          if (sorted === false) {
            column.toggleSorting(true); // desc
          } else if (sorted === "desc") {
            column.toggleSorting(false); // asc
          } else {
            column.clearSorting(); // clear
          }
        }}
      >
        <span>{title}</span>
        {sorted === "desc" ? (
          <ArrowDown className="ml-2 h-4 w-4" />
        ) : sorted === "asc" ? (
          <ArrowUp className="ml-2 h-4 w-4" />
        ) : (
          <ArrowUpDown className="ml-2 h-4 w-4 opacity-50" />
        )}
      </Button>
    </div>
  );
}

